import Modal from '@/components/Common/Modal';
const CrossIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.86667 13.4168L0.583332 12.1335L5.71667 7.00016L0.583332 1.86683L1.86667 0.583496L7 5.71683L12.1333 0.583496L13.4167 1.86683L8.28333 7.00016L13.4167 12.1335L12.1333 13.4168L7 8.2835L1.86667 13.4168Z"
        fill="black"
      />
    </svg>
  );
};
const VariantOptionModal = ({
  activeVariantGroup,
  variantOptions = [],
  activeVariantOption,
  onClose,
  onClick,
}) => {
  const Heading = () => {
    return (
      <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-[#E9E9E9] tw-p-[16px]">
        <span className="tw-text-sm tw-font-semibold">Select {activeVariantGroup}</span>
        <div onClick={onClose}>
          <CrossIcon />
        </div>
      </div>
    );
  };

  const VariantOption = ({ variant }) => {
    if (!variant?.visible) {
      return null;
    }

    const handleVariantClick = (variantName) => {
      onClick(variantName);
      onClose();
    };

    return (
      <li
        className={`tw-border-b tw-border-solid tw-border-[#E9E9E9] tw-p-[16px] tw-font-normal ${!variant?.available && 'tw-text-[#999]'} ${variant?.value === activeVariantOption && 'tw-bg-[#f7f7f7]'}`}
        onClick={() => handleVariantClick(variant?.value)}
      >
        {variant?.value}
      </li>
    );
  };

  const VariantOptionsList = () => {
    return (
      <ul className="tw-list-none">
        {variantOptions?.map((variant, index) => (
          <VariantOption key={index} variant={variant} />
        ))}
      </ul>
    );
  };

  return (
    <Modal
      visible={true}
      className="bottom-modal"
      animation={'slideUp'}
      onClose={onClose}
      height="auto"
      customStyles={{ padding: 0, maxHeight: '400px', overflowY: 'auto' }}
    >
      <div>
        <Heading />
        <VariantOptionsList />
      </div>
    </Modal>
  );
};

export default VariantOptionModal;
